import React from "react";
import AllergyDetails from "./AllergyDetails";
import ChronicCondition from "./ChronicCondition";
import FamilyHistory from "./FamilyHistory";
import Vitals from "./Vitals";
import HealthTrends from "./HealthTrends";
import SocialHistory from "./SocialHistory";
import PastMedicalHistory from "./PastMedicalHistory";
import SurgicalHistory from "./SurgicalHistory";
import Medication from "./Medication";
import Immunization from "./Immunization";
import EmergencyCard from "./EmergencyCard";
import backimage from "../../../Assets/Images/medicalimage.jpg";
import { DatePicker } from 'antd';



function HealthSummary() {
  return (
    <div
      className="w-full overflow-y-scroll h-screen bg-cover bg-center bg-fixed bg-blue-50"
      // style={{ backgroundImage: `url(${backimage})` }}
    >
      <div className="bg-blue-950">
         <div className="flex justify-between p-3">
          <h2 className="font-bold text-xl text-white">Health Summary</h2>
          {/* <input
            type="date"
            className="border rounded-lg p-2 bg-cyan-50 text-sm text-gray-500 outline-none placeholder-gray-400"
            onFocus={(e) => (e.placeholder = "")}
            onBlur={(e) => (e.placeholder = "Select Date")}
            placeholder="Select Date"
          /> */}
          <DatePicker classname="custom-datepicker"/>
          
        </div>
        </div>
      <div className="w-[95%] m-auto mt-5">      
        <div className=" grid grid-cols-3 border rounded-lg">
          <AllergyDetails />
          <PastMedicalHistory />
          <Immunization />
          <FamilyHistory />
          <SocialHistory />
          <Medication />
          <SurgicalHistory />
          <ChronicCondition />
          <Vitals />
          <HealthTrends />
          <EmergencyCard />
        </div>
      </div>
    </div>
  );
}

export default HealthSummary;
